import { gql } from 'urql';

const CancelChargeCardPayment = gql`
  mutation CancelChargeCardPayment($id: ID!) {
    cancelChargeCardPayment(id: $id) {
      __typename
      ... on CancelChargeCardPaymentSuccess {
        message
      }
    }
  }
`;

export default CancelChargeCardPayment;
